module.exports = __webpack_public_path__ + "img/百香果15.bcf39418.png";